import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CreateCategory from "./Create Category/CreateCategory";
import { useDispatch, useSelector } from "react-redux";
import { DeleteQuizcategorySlice, ListquizcategorySlice } from "../../../../redux/features/Quiz Management/QuizCategory";
import { FaEdit } from "react-icons/fa";
import UpdateCategory from "./Update Category/UpdateCategory";

const QuizCategory = () => {
  const navigate = useNavigate();
  const [state, setState] = useState({ add: false, update: true });
  const [iState, setUpdate] = useState([]);
  const [dataHold, setDataHold] = useState("");

  const dispatch = useDispatch();

  const { CreateQuizCategory,UpdateQuizCategory,DeleteQuizCategory} = useSelector((state) => state?.QuizCategory);

  useEffect(() => {
    dispatch(ListquizcategorySlice())?.then((res) => {
      // console.log(res);
      if (res?.payload?.customStatus === 200) {
        setUpdate(res?.payload?.data);
      }
    });
  }, [CreateQuizCategory,UpdateQuizCategory,DeleteQuizCategory]);

  const deleteQuizCategory=(id)=>{
    console.log(id)
    dispatch(DeleteQuizcategorySlice(id))?.then((res) => {
      console.log(res);
      if (res?.payload?.customStatus === 200) {
        setUpdate(res?.payload?.data);
      }
    });
  }

  return (
    <>
      <div className="TitleBox">
        <h4 className="Title" />
        <span>
          {" "}
          <a className="TitleLink" onClick={() => navigate(-1)}>
            Back
          </a>
          <a
            className="TitleLink"
            data-toggle="modal"
            data-target="#AddQuizCategoryModal"
            onClick={() => setState((prev) => ({ ...prev, add: !prev["add"] }))}
          >
           Add Quiz Category
          </a>
        </span>
      </div>

      <div className="Small-Wrapper">
        <div className="TableList">
          <table>
            <thead>
              <tr>
                <th>S.No.</th>
                <th>Category ID</th>
                <th>Category Name</th>
                <th>Category Image</th>
                <th>Uploaded On</th>
                <th>Last Updated On</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {Array.isArray(iState) &&
                iState?.map((item, index) => {
                  return (
                    <tr>
                      <td>{index + 1}</td> 
                      <td>{item?.categoryId}</td>
                      <td>{item?.categoryName}</td>
                      <td>
                        <img
                          src={item?.categoryImage}
                          style={{
                            height: 80,
                            width: 80,
                            borderRadius: "100%",
                          }}
                        />
                      </td>
                      <td>{item?.createdAt?.slice(0, 10)}</td>
                      <td>{item?.updatedAt?.slice(0, 10)}</td>
                      <td>
                        <div className="Actions">
                          <a
                            className="Red"
                            data-toggle="modal"
                            data-target="#DeleteCategoryModal"
                            onClick={()=>setDataHold(item?._id)}
                          >
                            <i className="fa fa-trash" aria-hidden="true" />
                          </a>
                          <a
                            className="Green"
                            data-toggle="modal"
                            data-target="#UpdateModal"
                            // href="#/ContentManagement/PublishArticleByAdmin/CategoryList/1"
                            data-discover="true"
                            onClick={() => {
                              setState((prev) => ({
                                ...prev,
                                update: !prev["update"],
                              }));
                              setDataHold(item)
                            }}
                          >
                            <FaEdit />
                          </a>
                        </div>
                      </td> 
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>

      <div className="ModalBox">
        {state?.add && <CreateCategory setState={setState} />}
        {state?.update && <UpdateCategory setState={setState} data={dataHold} />}
       
        
        <div id="DeleteCategoryModal" className="modal fade" role="dialog">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-body">
                <div className="Decline">
                  <a
                    href="javascript:void(0);"
                    className="CloseModal"
                    data-dismiss="modal"
                  >
                    ×
                  </a>
                  <h3>Reject</h3>
                  <p>Are you sure you want to delete? </p>
                  <h4>
                    <a href="javascript:void(0);" data-dismiss="modal">
                      no
                    </a>
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      onClick={() => deleteQuizCategory(dataHold)}
                    >
                      Yes
                    </a>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      
    </>
  );
};

export default QuizCategory;
